import Column from "./Column";
import PropTypes from "prop-types";
import React from "react";
import Row from "./Row";
import Section from "./Section";
import styled from "styled-components";
import AccountSelector from "./AccountSelector";

const TopBarMobile = ({ title, subTitle }) => {
  return (
    <TopBarStyle>
      <Section margin="0 0 0px" padding="16px" bgColor="transparent" boxShadow="none">
        <Row>
          <Column>
            <AccountSelector mobile />
          </Column>
        </Row>
        <Row className="top-bar" alignItems="left">
          <Column align="left">
            {subTitle && <SubTitleStyle>{subTitle}</SubTitleStyle>}
            <Column>{title}</Column>
          </Column>
        </Row>
      </Section>
    </TopBarStyle>
  );
};

TopBarMobile.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default TopBarMobile;

const SubTitleStyle = styled.div`
  font-weight: 700;
  color: #afafaf;
  font-size: 12px;
`;

const TopBarStyle = styled.div`
  margin: 0 8px 0px 8px !important;
  font-weight: 700;
`;

const RowStyle = styled(Row)`
  justify-content: center !important;
`;
